import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, Users, Building, Award, MapPin, Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const WhyChooseUsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[350px] flex items-center justify-center overflow-hidden bg-[#0077B6]">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0077B6] to-[#005A8C]" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-3 text-white">Why Choose Utmost Financial</h1>
          <p className="text-lg text-blue-100">
            Experience the difference of working with dedicated financial professionals
          </p>
        </div>
      </section>

      {/* What Sets Us Apart Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* What Sets Us Apart */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-4">What Sets Us Apart</h2>
            <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-12"></div>
            
            <div className="grid md:grid-cols-2 gap-8">
              <Card className="bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 border-2 border-[#0077B6] flex items-center justify-center flex-shrink-0">
                      <CheckCircle className="h-6 w-6 text-[#0077B6]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-3">Comprehensive Solutions</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Insurance, investments, and mortgages all under one roof for seamless financial planning. No need to work with multiple providers – we handle it all.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border-2 border-[#D4AF37] flex items-center justify-center flex-shrink-0">
                      <Users className="h-6 w-6 text-[#D4AF37]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-3">Personalized Service</h3>
                      <p className="text-gray-600 leading-relaxed">
                        We take the time to understand your unique situation, goals, and values to create tailored solutions that truly fit your needs.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 border-2 border-[#0077B6] flex items-center justify-center flex-shrink-0">
                      <Award className="h-6 w-6 text-[#0077B6]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-3">Licensed Professionals</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Our team of licensed advisors brings years of experience and ongoing professional development to serve you better.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border-2 border-[#D4AF37] flex items-center justify-center flex-shrink-0">
                      <MapPin className="h-6 w-6 text-[#D4AF37]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-3">Multi-Province Coverage</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Licensed to serve clients across Manitoba, Saskatchewan, Alberta, and British Columbia – wherever life takes you.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-[#0077B6]/10 border-2 border-[#0077B6] flex items-center justify-center flex-shrink-0">
                      <Building className="h-6 w-6 text-[#0077B6]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-3">Industry Partnerships</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Through our partnership with Dominion Lending Centres and leading insurance carriers, we offer competitive rates and diverse product options.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-[#F0F7FF] border border-blue-100 hover:border-[#0077B6] transition-all hover:shadow-lg">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border-2 border-[#D4AF37] flex items-center justify-center flex-shrink-0">
                      <Heart className="h-6 w-6 text-[#D4AF37]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-3">Community Focused</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Based in Winnipeg, we're proud to serve our local community and build lasting relationships with our clients and neighbors.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#0077B6]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-3">Ready to Experience the Difference?</h2>
          <p className="text-blue-100 mb-6 text-lg">
            Join thousands of satisfied clients who trust Utmost Financial for their financial needs
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-[#D4AF37] hover:bg-[#B8962E] text-[#003D5C] font-bold text-lg px-8">
              <Link to="/team">Meet Our Team</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-[#0077B6] font-bold text-lg px-8">
              <a href="tel:18772399060">Call 1-877-239-9060</a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUsPage;
